import React from "react";

const BackOfficeContext = React.createContext();
BackOfficeContext.displayName = "BackofficeContext";

//the actual context data is declared in App.js
export const useBackOfficeContext = () => React.useContext(BackOfficeContext);

export default BackOfficeContext;
